<template>
  <div :class="[baseCss, `${baseCss}-${type}`, 'select-none']">
    <card v-if="type === 'datetime'" :elevation="elevation" :rounded="rounded">
      <card-text padding-off>
        <tab padding-off :class="[`${baseCss}-tabs`]" :icon-provider="iconProvider" :dense="dense" :selected-marker-color="color" :selected-marker-color-lightness="colorLightness" name="datetimepicker-tab" :bg-color="bgColor" :bg-color-lightness="bgColorLightness" :color="color" :color-lightness="colorLightness">
          <tab-panel :label="lang.date" :icon="icons.date">
            <datetime-picker-date @datedblclick="onDateDblclick" @dateweekdayclick="onDateWeekdayClick" @input="onDatePickerDateInput" :min-date="minDate" :max-date="maxDate" :dropdowns-height="dropdownsHeight" :selected-color="selectedColor" :selected-color-lightness="selectedColorLightness" :show-weekdays="showWeekdays" :prev-next-navigation="prevNextNavigation" :year-month-selection="yearMonthSelection" :icons="icons" :icon-provider="iconProvider" :date-min-height="dateMinHeight" :color="color" :type="type" :color-lightness="colorLightness" :bg-color="bgColor" :bg-color-lightness="bgColorLightness" :locale="locale" :date="date" :labels="labels" :week-starts-on-monday="weekStartsOnMonday" :weekdays="weekdays" />
          </tab-panel>
          <tab-panel :label="lang.time" :icon="icons.time">
            <datetime-picker-time @timeinput="onTimePickerInput" :time-picker-segments="timePickerSegments" :date="date" :height="dateMinHeight" :bg-color="bgColor" :bg-color-lightness="bgColorLightness" />
          </tab-panel>
        </tab>
      </card-text>
    </card>
    <datetime-picker-date v-if="['date', 'custom'].includes(type)" @dateweekdayclick="onDateWeekdayClick" @datedblclick="onDateDblclick" @input="onDatePickerDateInput" :min-date="minDate" :max-date="maxDate" :dropdowns-height="dropdownsHeight" :selected-color="selectedColor" :selected-color-lightness="selectedColorLightness" :rounded="rounded" :elevation="elevation" :show-weekdays="showWeekdays" :prev-next-navigation="prevNextNavigation" :year-month-selection="yearMonthSelection" :icon-provider="iconProvider" :icons="icons" :date-min-height="dateMinHeight" :color="color" :type="type" :color-lightness="colorLightness" :bg-color="bgColor" :bg-color-lightness="bgColorLightness" :locale="locale" :date="date" :labels="labels" :week-starts-on-monday="weekStartsOnMonday" :weekdays="weekdays" />
    <card v-if="type === 'time'" :elevation="elevation" :rounded="rounded">
      <card-text padding-off>
        <datetime-picker-time @timeinput="onTimePickerInput" :time-picker-segments="timePickerSegments" :date="date" :height="dateMinHeight" :bg-color="bgColor" :bg-color-lightness="bgColorLightness" />
      </card-text>
    </card>
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'DatetimePicker',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('datetime-picker', [])
    }
  },
  props: {
    dropdownsHeight: {
      type: String,
      default: '192px'
    },
    timePickerSegments: {
      type: Array,
      default () {
        return ['hours', 'minutes', 'seconds', 'am/pm']
      }
    },
    minDate: {
      type: String
    },
    maxDate: {
      type: String
    },
    rounded: {
      type: Boolean,
      default: true
    },
    selectedColor: {
      type: String,
      default: 'white'
    },
    selectedColorLightness: {
      type: String,
      default: null
    },
    icons: {
      type: Object,
      default () {
        return {
          navLeft: 'chevron-left',
          navRight: 'chevron-right',
          date: 'calendar',
          time: 'clock'
        }
      }
    },
    elevation: {
      type: String,
      default: 'md',
      validator: value => {
        return [
          'sm',
          'md',
          'lg',
          'xl',
          '2xl',
          'inner',
          'none'
        ].includes(value)
      }
    },
    showWeekdays: {
      type: Boolean,
      default: true
    },
    prevNextNavigation: {
      type: Boolean,
      default: true
    },
    yearMonthSelection: {
      type: Boolean,
      default: true
    },
    iconProvider: {
      type: String,
      default: 'mdi'
    },
    dense: {
      type: Boolean,
      default: true
    },
    bgColor: {
      type: String,
      default: 'gray'
    },
    bgColorLightness: {
      type: Number,
      default: 300
    },
    color: {
      type: String,
      default: 'black'
    },
    colorLightness: {
      type: Number,
      default: null
    },
    dateMinHeight: {
      type: String,
      default: '32px'
    },
    lang: {
      type: Object,
      default () {
        return {
          date: 'Date',
          time: 'Time'
        }
      }
    },
    locale: {
      type: String,
      default: 'en-US'
    },
    type: {
      type: String,
      default: 'datetime',
      validator: value => {
        return [
          'custom',
          'date',
          'datetime',
          'time'
        ].includes(value)
      }
    },
    date: {
      type: [String, Object],
      default: new Date().toISOString()
    },
    labels: {
      type: String,
      default: 'long',
      validator: value => {
        return [
          'long',
          'short'
        ].includes(value)
      }
    },
    weekStartsOnMonday: {
      type: Boolean,
      default: true
    },
    weekdays: {
      type: Array,
      default () {
        return [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday'
        ]
      }
    }
  },
  mounted () {
    console.log(this.date)
  },
  methods: {
    onDatePickerDateInput ($event) {
      console.log('@input', 'date', $event)
    },
    onDateDblclick ($event) {
      console.log('@datedblclick', 'date', $event)
    },
    onDateWeekdayClick ($event) {
      console.log('@weekdayclick', 'date', $event)
    },
    onTimePickerInput ($event) {
      console.log('@timeinput', 'time', $event)
    }
  }
}
</script>
<style>
.bcq-datetime-picker .bcq-datetime-picker-tabs .bcq-tab-panel > .bcq-container > div
{
  padding: 0;
}

.bcq-datetime-picker .bcq-datetime-picker-tabs .bcq-tab-buttons .bcq-line-ripple
{
  height: 2px !important;
}

.bcq-datetime-picker .bcq-datetime-picker-tabs .bcq-carousel > div > div > .inline-list > li
{
  /*vertical-align: top;*/
}

.bcq-datetime-picker .cq-dropdown-items-container
{
  padding: 0;
}

.bcq-datetime-picker.bcq-datetime-picker-datetime li[role="tabpanel"]:nth-of-type(2)
{
  margin-left: -4px;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/datetime-picker/datetime-picker.vue